import React, { useState, FormEvent } from 'react';
import api from '../../Services/api';
import Input from '../../Components/Input';
import { useHistory } from "react-router-dom";
import { useAblContext } from '../../Hooks/useAblContext';

export default function Login() {
  const [login , setLogin] = useState('');
  const [password , setPassword] = useState('');
  const [message, setMessage] = useState('');
  const history = useHistory();
  const abl = useAblContext();

  const handleLogin = async (e:FormEvent) => {
    try{
      e.preventDefault();
      const body = {
        email: login,
        password
      }
      const response = await api.post('session', body);
      if(response.data.token){
        localStorage.setItem("@authToken", response.data.token)

        const { role } = JSON.parse(atob(response.data.token.split('.')[1]));

        abl.saveRoles(role[0]);
        abl.saveAuthenticated(true);
        abl.saveToken(`bearer ${response.data.token}`)
        history.push("/home");
        return;
      }
      throw new Error('Houve um erro ao processar sua solicitação');
    } catch( err) {
      console.log(err.message);
      setMessage('Usuário ou senha inválido!');
    }
  }

  return(
    <>
    <body className="login">
        <div className="box-login">
            <img src="img/logo.png" alt="" />
			{/* <!-- VALIDA PARA QUAL HOME O USUÁRIO VAI --> */}
            <form name="login" >
                  <Input  name="login"
                    value={login}
                    placeholder="Entre com seu Email"
                    onChange={(e) => { setLogin(e.target.value)}}
                  />
                <Input name="senha"
                    type={"password"}
                    placeholder="Digite sua senha"
                    value={password}
                    onChange={(e) => { setPassword(e.target.value)}}
                  />
                {/* <input type="password" name="senha" id="senha" placeholder="SENHA"/> */}
                <input type="submit" value="ENTRAR" onClick={handleLogin} />
                { message && <span id="spanLogin" className="erro">{message} </span>}
            </form>
        </div>
    </body>
    </>
  )
}
